import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guard/auth.guard';
import { QrAuthGuard } from './core/guard/qr-auth.gaurd';
import {RemoveAccountComponent} from "./auth/remove-account/remove-account.component";

const routes: Routes = [
  {path:'report-breach', canMatch:[QrAuthGuard], loadChildren: () => import('./auth/qr-code/qr-code-web.module').then(m => m.QrCodeWebModule)},
  {path:'remove-account', component: RemoveAccountComponent},
  {path:'', canMatch:[AuthGuard], loadChildren: () => import('../app/main/main.module').then(m => m.MainModule)},
  {path:'**', redirectTo:'', pathMatch:'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
